<template>
<div class="chapter">
<div class="inner_page">
<p class="block_10">
<span class="text_2">
</span></p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<h1 class="block_1" id="toc_id_4"><span class="text_">Acknowledgements</span></h1>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_2"> </p>
<p class="block_11"><span class="text_1">To Clare Broadbent for all her support and encouragement and for her unwavering belief in the book.</span></p>
<p class="block_12"> </p>
<p class="block_12"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_003.vue?61063b75